import React from "react";

import {

    Card,
    Space,
    Tag,
    Typography

} from "antd";

import {

    AppstoreOutlined

} from "@ant-design/icons";

const { Title, Text } = Typography;

const ConversationNotificationCardOld = ({

                                     notification

                                 }) => (

    <Card

        style={{

            marginBottom:15,

            borderRadius:12

        }}

    >

        <Space direction="vertical">

            <Title level={5}>

                <AppstoreOutlined />

                {" "}

                Produit

            </Title>

            <Text>

                {notification.productName}

            </Text>

            <Tag color="gold">

                {notification.status}

            </Tag>

        </Space>

    </Card>

);

export default ConversationNotificationCardOld;